export default [
  { name: 'Alba', code: 'AB' },
  { name: 'Arad', code: 'AR' },
  { name: 'Argeș', code: 'AG' },
  { name: 'Bacău', code: 'BC' },
  { name: 'Bihor', code: 'BH' },
  { name: 'Bistrița-Năsăud', code: 'BN' },
  { name: 'Botoșani', code: 'BT' },
  { name: 'Brașov', code: 'BV' },
  { name: 'Brăila', code: 'BR' },
  { name: 'București', code: 'B' },
  { name: 'Buzău', code: 'BZ' },
  { name: 'Călărași', code: 'CL' },
  { name: 'Caraș-Severin', code: 'CS' },
  { name: 'Cluj', code: 'CJ' },
  { name: 'Constanța', code: 'CT' },
  { name: 'Covasna', code: 'CV' },
  { name: 'Dâmbovița', code: 'DB' },
  { name: 'Dolj', code: 'DJ' },
  { name: 'Galați', code: 'GL' },
  { name: 'Giurgiu', code: 'GR' },
  { name: 'Gorj', code: 'GJ' },
  { name: 'Harghita', code: 'HR' },
  { name: 'Hunedoara', code: 'HD' },
  { name: 'Iași', code: 'IS' },
  { name: 'Ialomița', code: 'IL' },
  { name: 'Ilfov', code: 'IF' },
  { name: 'Maramureș', code: 'MM' },
  { name: 'Mehedinți', code: 'MH' },
  { name: 'Mureș', code: 'MS' },
  { name: 'Neamț', code: 'NT' },
  { name: 'Olt', code: 'OT' },
  { name: 'Prahova', code: 'PH' },
  { name: 'Sălaj', code: 'SJ' },
  { name: 'Satu Mare', code: 'SM' },
  { name: 'Sibiu', code: 'SB' },
  { name: 'Suceava', code: 'SV' },
  { name: 'Teleorman', code: 'TR' },
  { name: 'Timiș', code: 'TM' },
  { name: 'Tulcea', code: 'TL' },
  { name: 'Vâlcea', code: 'VL' },
  { name: 'Vaslui', code: 'VS' },
  { name: 'Vrancea', code: 'VN' }
];
